const confirms = {
    methods: {
        confirm (props, id = true) {
            throw new Error("**** use this.$confirm instead")
            /*
            this.confirmation_props = {
                type: "warning",
                icon: "exclamation-triangle",
                dismissable: false,
                title: "",
                message: "",
                cancel: this.$root.translate("No"),
                ok: this.$root.translate("Yes"),
                then: () => {},
                ...props
            }
            console.log(this.confirmation_props, props)
            this.confirming = id
            */
        }
    }
}

export default confirms
